import * as yup from 'yup'
import { createDataRef, createDataSchema } from '../schemaUtils'
import { ImageSchema } from './Image.schema'
import { ImageMaskSchema } from './ImageMask.schema'

export const videoBackgroundProperties = yup.object({
	enableBackgroundVideo: yup.boolean().meta({
		description: 'sets the component ability to play its background video on mobile',
	}),
})

export const VideoSchema = createDataSchema(
	'WixVideo',
	yup.object({
		title: yup.string().max(100),
		alt: yup.string().max(1000).notRequired(),
		videoId: yup.string(),
		generatedPosters: yup.array().of(yup.string()),
		qualities: yup.array().of(
			yup.object({
				quality: yup.string(),
				width: yup.number(),
				height: yup.number(),
				formats: yup.array().of(yup.string()).notRequired().meta({
					description:
						"Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality",
				}),
				format: yup.mixed<'mp4' | 'webm'>().oneOf(['mp4', 'webm']).default('mp4'),
				url: yup.string(),
			})
		),
		adaptiveVideo: yup
			.array()
			.of(
				yup.object({
					format: yup.mixed<'hls' | 'dash'>().oneOf(['hls', 'dash']).default('hls'),
					url: yup.string(),
				})
			)
			.notRequired(),
		posterImageRef: createDataRef({ Image: ImageSchema }).nullable(),
		duration: yup.number(),
		fps: yup.string().max(50),
		hasAudio: yup.boolean().meta({ description: 'video has no audio' }),
		artist: yup.object({ name: yup.string(), id: yup.string() }),
		loop: yup.boolean(),
		autoplay: yup.boolean(),
		playbackSpeed: yup.number(),
		preload: yup.mixed<'auto' | 'metadata' | 'none'>().oneOf(['auto', 'metadata', 'none']).default('none'),
		controls: yup.mixed<'none' | 'full'>().oneOf(['none', 'full']).default('none'),
		mute: yup.boolean().meta({ description: 'deprecated, moved to properties' }),
		opacity: yup.number(),
		mediaFeatures: yup
			.array()
			.of(yup.mixed<'alpha' | '360'>().oneOf(['alpha', '360']).notRequired())
			.default([]),
		mask: ImageMaskSchema.notRequired().nullable(),
	})
)
